import React from 'react';
import PropTypes from 'prop-types';
import { LuFilter, LuX } from 'react-icons/lu';

// Where the orphans came from. The counts per record type + attachment name are
// what point at the code path that leaked, so they lead — the row list below is
// for checking individual files.
const OrphanSummary = ({ total, groups, recordType, name, onPick, onClear }) => {
  const filtered = Boolean(recordType || name);

  return (
    <div className="tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-p-4">
      <div className="tw-flex tw-items-baseline tw-justify-between tw-gap-3 tw-mb-3 tw-flex-wrap">
        <div className="tw-flex tw-items-baseline tw-gap-2">
          <span className="tw-text-2xl tw-font-semibold tw-text-slate-900 tw-leading-none">{total}</span>
          <span className="tw-text-[13px] tw-text-slate-500">
            orphaned {total === 1 ? 'attachment' : 'attachments'}
            {filtered ? ' matching this filter' : ''}
          </span>
        </div>

        {filtered && (
          <button
            type="button"
            onClick={onClear}
            className="tw-inline-flex tw-items-center tw-gap-1 tw-text-[12px] tw-font-medium tw-text-slate-500 hover:tw-text-slate-800 tw-bg-transparent tw-border-0 tw-cursor-pointer"
          >
            <LuX size={12} /> Clear filter
          </button>
        )}
      </div>

      {groups.length === 0 ? (
        <p className="tw-text-[12.5px] tw-text-slate-400 tw-mb-0">Nothing to group.</p>
      ) : (
        <ul className="tw-list-none tw-p-0 tw-m-0 tw-flex tw-flex-col tw-gap-1">
          {groups.map((group) => {
            const active = group.record_type === recordType && group.name === name;
            return (
              <li key={`${group.record_type}/${group.name}`}>
                <button
                  type="button"
                  onClick={() => onPick(group)}
                  aria-pressed={active}
                  className={[
                    'tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-2 tw-py-1.5 tw-rounded',
                    'tw-text-left tw-text-[12.5px] tw-border tw-border-solid tw-cursor-pointer tw-transition-colors',
                    active
                      ? 'tw-bg-primary-50 tw-border-primary-200 tw-text-primary-800'
                      : 'tw-bg-white tw-border-transparent hover:tw-bg-slate-50 tw-text-slate-700',
                  ].join(' ')}
                >
                  <span className="tw-font-semibold tw-tabular-nums tw-w-10 tw-text-right tw-shrink-0">
                    {group.count}
                  </span>
                  <LuFilter size={11} className="tw-text-slate-300 tw-shrink-0" />
                  <span className="tw-truncate" title={`${group.record_type} / ${group.name}`}>
                    <span className="tw-text-slate-500">{group.record_type}</span>
                    <span className="tw-text-slate-300"> / </span>
                    <span className="tw-font-medium">{group.name}</span>
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

OrphanSummary.propTypes = {
  total:      PropTypes.number.isRequired,
  groups:     PropTypes.arrayOf(PropTypes.shape({
    record_type: PropTypes.string,
    name:        PropTypes.string,
    count:       PropTypes.number,
  })).isRequired,
  recordType: PropTypes.string,
  name:       PropTypes.string,
  onPick:     PropTypes.func.isRequired,
  onClear:    PropTypes.func.isRequired,
};

export default OrphanSummary;
